import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

const StatCard = ({ title, value, children, icon: Icon, bgColor, iconColor, to }) => {
    const navigate = useNavigate();
    const isClickable = !!to;

    const handleClick = () => {
        if (to) {
            navigate(to);
        }
    };

    return (
        <motion.div
            whileHover={{ scale: 1.03, y: -4 }}
            whileTap={{ scale: 0.98 }}
            onClick={handleClick}
            className={`${bgColor} p-5 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 ${
                isClickable ? "cursor-pointer" : ""
            } relative overflow-hidden group`}
        >
            {/* Decorative background elements */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16 group-hover:scale-110 transition-transform duration-300" />
            <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/5 rounded-full -ml-12 -mb-12" />
            
            <div className="relative z-10">
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-3">
                        <motion.div
                            whileHover={{ rotate: 15 }}
                            className={`p-3 rounded-xl ${iconColor} text-white shadow-md`}
                        >
                            <Icon className="w-6 h-6" />
                        </motion.div>
                        <h3 className="text-lg font-semibold text-white drop-shadow-sm">{title}</h3>
                    </div>
                    {isClickable && (
                        <motion.div
                            initial={{ x: 0, opacity: 0.7 }}
                            whileHover={{ x: 4, opacity: 1 }}
                            className="text-white/80 group-hover:text-white transition-colors"
                        >
                            <FiArrowRight className="w-5 h-5" />
                        </motion.div>
                    )}
                </div>
                
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    className="text-4xl font-bold text-white mb-4 drop-shadow-md"
                >
                    {value}
                </motion.div>
                
                <div className="flex flex-col xs:flex-row justify-between gap-2 bg-white/20 backdrop-blur-sm rounded-xl p-3">
                    {children}
                </div>
            </div>
        </motion.div>
    );
};

export default StatCard;